import { urgencia } from "@/lib/urgencia";

/** PROMPT 141: la etiqueta de urgencia según la fecha del tour ("Urgente · hoy", "Pronto · en 2 días"...). */
export default function UrgenciaBadge({ fecha, testid }) {
  const u = urgencia(fecha);
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0 rounded border text-[10px] font-semibold leading-4 ${u.cls}`}
      data-testid={testid}
      data-nivel={u.nivel}
    >
      {u.texto}
    </span>
  );
}
